/* eslint-disable arrow-body-style */
import { MEDICAL_HEALTH_SERVICE_CONFIG, SERVICE_CONFIG } from 'constant';
import { useLocation } from 'react-router-dom';

export function title(str) {
    return str.replace(/(^|\s)\S/g, (t) => t.toUpperCase());
}

export const getEmployeeName = (employee) => {
    if (!employee) return '';

    // eslint-disable-next-line no-nested-ternary
    const name = employee.name
        ? employee.name
        : employee.first_name && employee.last_name
          ? `${employee.first_name} ${employee.last_name}`
          : '';
    const credentials = employee.credentials ? `, ${employee.credentials}` : '';
    const npi = employee.npi ? ` (${employee.npi})` : '';
    return `${name}${credentials}${npi}`;
};

export const GetServiceTypeFromPath = () => {
    const { pathname } = useLocation();

    const matchedKey = Object.keys(SERVICE_CONFIG).find((key) => pathname?.toLowerCase()?.includes(key));

    return matchedKey ? SERVICE_CONFIG[matchedKey] : null;
};

export const GetServiceTypeFromValue = (value) => {
    const matchedKey = Object.keys(SERVICE_CONFIG).find((key) => value?.toLowerCase()?.includes(key));

    return matchedKey ? SERVICE_CONFIG[matchedKey] : null;
};

export const GetMedicalHealthServiceFromPath = () => {
    const { pathname } = useLocation();

    const matchedKey = Object.keys(MEDICAL_HEALTH_SERVICE_CONFIG).find((key) => pathname?.toLowerCase()?.includes(key));

    return matchedKey ? MEDICAL_HEALTH_SERVICE_CONFIG[matchedKey] : null;
};

export const GetMedicalHealthServiceFromValue = (value) => {
    const matchedKey = Object.keys(MEDICAL_HEALTH_SERVICE_CONFIG).find((key) => value?.toLowerCase()?.includes(key));

    return matchedKey ? MEDICAL_HEALTH_SERVICE_CONFIG[matchedKey] : null;
};

export const SumOfArray = (arr) =>
    arr.reduce((total, value) => {
        const num = Number(value);
        return total + (Number.isFinite(num) ? num : 0);
    }, 0);

export const filterObjectsWithMeaningfulValue = (array, keys) => {
    return array.filter((item) =>
        keys.some((key) => {
            const value = item[key];

            // Null or undefined check
            if (value === null || value === undefined) return false;

            // Empty string check
            if (typeof value === 'string' && value.trim() === '') return false;

            // Empty object check
            if (typeof value === 'object' && !Array.isArray(value)) {
                return Object.keys(value).length > 0;
            }

            // Empty array check
            if (Array.isArray(value) && value.length === 0) return false;

            return true;
        })
    );
};

export const getPatientDiagnosisFromServiceInfo = (patient, serviceId) => {
    if (!patient || !serviceId) return null;

    const serviceInfo = patient?.service_info?.find((si) => String(si?.service) === String(serviceId));

    const primaryDiagnosis = serviceInfo?.primary_diagnosis;
    if (!primaryDiagnosis?.id) return null;

    return {
        id: primaryDiagnosis.id,
        icd_code: primaryDiagnosis.icd_code ?? primaryDiagnosis.code ?? '',
        description: primaryDiagnosis.description ?? primaryDiagnosis.name ?? ''
    };
};
